export const GET_PAST_NOTIFICATIONS = "GET_PAST_NOTIFICATIONS";
export const GET_PAST_NOTIFICATIONS_SUCCESS = "GET_PAST_NOTIFICATIONS_SUCCESS";
export const GET_PAST_NOTIFICATIONS_FAILURE = "GET_PAST_NOTIFICATIONS_FAILURE";
export const GET_PRESENT_NOTIFICATIONS = "GET_PRESENT_NOTIFICATIONS";
export const GET_PRESENT_NOTIFICATIONS_SUCCESS = "GET_PRESENT_NOTIFICATIONS_SUCCESS";
export const GET_PRESENT_NOTIFICATIONS_FAILURE = "GET_PRESENT_NOTIFICATIONS_FAILURE";
export const GET_FUTURE_NOTIFICATIONS = "GET_FUTURE_NOTIFICATIONS";
export const GET_FUTURE_NOTIFICATIONS_SUCCESS = "GET_FUTURE_NOTIFICATIONS_SUCCESS";
export const GET_FUTURE_NOTIFICATIONS_FAILURE = "GET_FUTURE_NOTIFICATIONS_FAILURE";
export const FETCHING_NOTIFICATIONS = "FETCHING_NOTIFICATIONS";


// WEBPACK FOOTER //
// ./src/types/notificationActionTypes.js